import React, { useState } from 'react';

interface TestingToolsProps {
  onAuthChange: (isAuthenticated: boolean) => void;
}

const TestingTools: React.FC<TestingToolsProps> = ({ onAuthChange }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [mockAuthenticated, setMockAuthenticated] = useState(false);

  const handleAuthToggle = () => {
    const newAuthState = !mockAuthenticated;
    setMockAuthenticated(newAuthState);
    onAuthChange(newAuthState);
  };

  return (
    <div className="testing-tools">
      <button 
        className="testing-tools-toggle"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        Testing Tools {isExpanded ? '▼' : '▶'}
      </button>
      
      {isExpanded && (
        <div className="testing-tools-content">
          <button 
            className={`auth-toggle-button ${mockAuthenticated ? 'logged-in' : 'logged-out'}`}
            onClick={handleAuthToggle}
          >
            {mockAuthenticated ? 'Log Out' : 'Log In'}
          </button>
        </div>
      )}
    </div>
  );
};

export default TestingTools; 